import React from "react";
import { connect, useSelector } from "react-redux";

import { selectLessons } from "../../redux/lessons/lessons.selectors";
import {
	SuggestedVideosContainer,
	Text,
} from "./suggested-videos-column.styles";
import SuggestedVideo from "../suggested-video/suggested-video.component";
import MiniLessonsThumbnail from "../mini-lessons-thumbnail/mini-lessons-thumbnail.component";

import {
	selectNewestMiniLessonID,
	selectNewestMiniLessonVideoThumbnailURL,
} from "../../redux/mini-lessons/mini-lesson.selectors";

const SuggestedVideosColumn = props => {
	const { lessons, hasAccess } = props;
	const videoURL = useSelector(selectNewestMiniLessonVideoThumbnailURL);
	const videoID = useSelector(selectNewestMiniLessonID);

	return (
		<SuggestedVideosContainer {...{ $columnCount: props.$columnCount }}>
			{props.hideMiniLessons ? null : (
				<MiniLessonsThumbnail
					videoURL={videoURL}
					miniLessonID={videoID}
					isHLSType={false}
				/>
			)}

			{lessons.map(lesson => {
				return (
					<SuggestedVideo
						key={lesson.DocID}
						{...lesson}
						isLocked={!lesson.isFree && !hasAccess}
						match={props.match}
					/>
				);
			})}
			<Text>scroll to the bottom to load more</Text>
		</SuggestedVideosContainer>
	);
};

const mapStateToProps = state => ({
	lessons: selectLessons(state),
});

export default connect(mapStateToProps)(SuggestedVideosColumn);
